<!-- header -->
<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-toggle>
        <ion-button>
          <ion-icon slot="icon-only" name="menu"></ion-icon>
        </ion-button>
      </ion-menu-toggle>
    </ion-buttons>

    <ion-buttons slot="end" class="ion-margin-end ion-padding-end">
      <ion-button
        class="button-with-icon"
        routerLink="/account"
        routerDirection="root"
        (click)="onAccountClicked()"
      >
        <ion-icon name="person"></ion-icon> {{ 'menu_account' | translate }}
      </ion-button>
      <ion-button class="button-with-icon" (click)="onLogout()">
        <ion-icon name="power"></ion-icon> {{ 'menu_logout' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
